import {
  removeNodesOnBreakpoints,
  replacePlaceholders,
  subscribeToResize,
} from '@msc-b2c/shared-utils';

export function updateFooterYear(): void {
  const lowerFooter = document.querySelector('.cmp-bottomContainer');
  if (!lowerFooter) {
    return;
  }

  const textElements = lowerFooter.querySelectorAll('.text');
  textElements.forEach((el) => {
    // Check if the element has the 'footer-copyright' class
    if (el.classList.contains('-footer-copyright')) {
      const currentText = el.textContent;

      if (currentText) {
        const textParts = currentText.split(' ');
        const restOfText = textParts.slice(1).join(' ');
        el.textContent = `© ${new Date().getFullYear()} ${restOfText}`;
      }
    }
  });
}

export function updateCopyrightYear(): void {
  const copyrightElement = document.querySelector('.terms-conditions-privacy-copyright .cmp-text');
  const copyrightElementLight = document.querySelector('.-footer-copyright .cmp-text');

  if (copyrightElement) {
    let copyrightText = copyrightElement?.innerHTML;
    const currentYear = new Date().getFullYear();
    copyrightText = replacePlaceholders(copyrightText, {
      year: currentYear.toString() ?? '',
    });
    copyrightElement.innerHTML = copyrightText;
  }
  if (copyrightElement || copyrightElementLight) {
    const loaderElement = document.querySelector('.loader');
    if (loaderElement) {
      const loaderSeparators = loaderElement.parentElement?.querySelectorAll('.separator');
      loaderSeparators?.forEach((separator) => separator.classList.add('hide'));
    }
  }
}

export function manageDuplicateIdsOnFooter() {
  const footerParent = document.querySelector('.cmp-footer-msc > .cmp-container > .aem-Grid');
  if (!footerParent) return;
  if (!footerParent.parentElement?.parentElement?.classList.contains('check-duplicate-ids')) return;

  const nodeClones: Record<'desktop' | 'mobile', Map<Element, [Element, boolean]>> = {
    desktop: new Map<Element, [Element, boolean]>(),
    mobile: new Map<Element, [Element, boolean]>(),
  };

  const mobileFooterAccordion = footerParent.querySelector('.cmp-footer-accordion');
  if (!mobileFooterAccordion) return;
  const desktopFooter = footerParent.querySelector('.cmp-upperContainer');
  if (!desktopFooter) return;

  nodeClones.desktop.set(footerParent, [desktopFooter, true]);
  nodeClones.mobile.set(footerParent, [mobileFooterAccordion, true]);

  removeNodesOnBreakpoints(nodeClones);

  // Use shared singleton resize listener (prevents N blocking listeners).
  const cleanup = subscribeToResize(() => {
    if (!footerParent.isConnected) {
      cleanup();
      return;
    }
    removeNodesOnBreakpoints(nodeClones);
  });
}

/**
 * Hides the .text.-footer-copyright wrapper (outside .cmp-bottomContainer)
 * when no text content has been authored (i.e. #bf-tnc-text is absent or empty).
 */
export function hideEmptyBfTncText(): void {
  const textFooterCopyrightEls = document.querySelectorAll('.text.-footer-copyright');

  textFooterCopyrightEls.forEach((el) => {
    // Skip the one inside .cmp-bottomContainer — that is the year copyright text
    if (el.closest('.cmp-bottomContainer')) {
      return;
    }

    if (!el.textContent?.trim()) {
      (el as HTMLElement).style.display = 'none';
    }
  });
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', () => {
      updateFooterYear();
      manageDuplicateIdsOnFooter();
      hideEmptyBfTncText();
    })
  : (function () {
      updateFooterYear();
      manageDuplicateIdsOnFooter();
      hideEmptyBfTncText();
    })();
